import React, {useState, useEffect} from "react";
import {Routes, Route, useNavigate,useLocation,useParams} from 'react-router-dom';
import moment from 'moment';
import {  Table, Select, DatePicker, Spin, Input, Tooltip, Typography,Breadcrumb } from 'antd';
import { ArrowRightOutlined, HomeOutlined, ContactsOutlined } from '@ant-design/icons';
import { FaAngleDoubleLeft } from "react-icons/fa";

import * as Styled from './style.js';
import { postData,getData } from '../../config/api-connect';
import Spinner from '../../components/spinner'
import PercentageBadge from '../../components/percentageBadge'
import {Link} from 'react-router-dom';

const { Option } = Select;
const { TextArea } = Input;

const BatchDetails = () => {
  const navigate = useNavigate();
  const { venue_id, game_level } = useParams();
  var local_selectedVenueId = venue_id
  var local_game_level = game_level

  var local_game_type = JSON.parse(localStorage.getItem('gameType'))

  const [loading, setLoading] = useState(true)
  const [selectedVenueId, setSelectedVenueId] = useState(local_selectedVenueId)
  const [batchesData, setBatchesData] = useState([])
  const [venueName, setVenueName] = useState('')
  const [gameType, setGameType] = useState(local_game_type)
  const [gameLevel, setGameLevel] = useState(local_game_level)
  const location = useLocation();
  const [page, setPage] = useState('')

  useEffect(() => {
    if(location.pathname.includes('utilization'))
      setPage('utilization')
    else
      setPage('attendance')
  },[])

  useEffect(() => {
    setLoading(true)
    if(page!='')
      getBatchDetails()

  }, [selectedVenueId,page]); 


  const getBatchDetails = () => {
    var url = `/business/get_batches_overview/?venue_id=${selectedVenueId}&game_type_id=${gameType}&game_level=${gameLevel}&page=${page}`;
    if(gameLevel == 'All'){
      url = `/business/get_batches_overview/?venue_id=${selectedVenueId}&game_type_id=${gameType}&page=${page}`
    }

    getData(url)
    .then(response =>{
      setBatchesData(response.result)
      if(response.result[0]){
        setVenueName(response.result[0].venue)
      }
      setLoading(false)
    })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }

  const rowClassName = (record) => {
    if (record.utilization >= 80) {
      return 'high-utilization-row';  
    } else if (record.utilization > 40) {
      return 'medium-utilization-row';
    } else {
      return 'low-utilization-row';
    }
  };



  const attendance_columns = [
    {
      title: 'Batch',  
      fixed: 'left',
      width: 220,  
      render: (_, record) => {
      const { start_time, end_time, days, multi_timings, id } = record;

      return (
        <div>
          <div>
            {
              (multi_timings && multi_timings.length > 0) ?
              <div>
                {
                  multi_timings.map(x=>(
                    <div style={{display:'flex'}}>
                      <span style={{flex:1}}>{x.day + ' : '}</span>
                      <span style={{flex:4}}>{x.start_time + ' - ' + x.end_time}</span>
                    </div>
                    ))
                }
              </div>
            :
              <div>
                <div>{days}</div>
                <div>{start_time + ' - ' + end_time}</div>
              </div>
            }
          </div>
        </div>
      );
    },
    },
    {
      title: 'Age Group',
      align: 'center',
      dataIndex: 'age_group_str',
      sorter: (a, b) => a.age_group_str.localeCompare(b.age_group_str),
    },

    ...(gameLevel === 'All' ? [{
      title: 'Skill Level',
      align: 'center',
      dataIndex: 'game_level_str',
      sorter: (a, b) => a.game_level_str.localeCompare(b.game_level_str)
    }] : []),

    {
      title: 'Coach',
      dataIndex: 'buddy_names',
      render: (value) => {
        return(
          <div>
            {
              value.map(x=>(
                <div>{x}</div>
                ))
            }
          </div>
          )
      },

    },
    {
      title: 'Customers',
      align: 'center',
      render: (_, record) => {
      const { active_count,paymentdue_count} = record;
        return (
          <div>
            {(Number(active_count) + Number(paymentdue_count))}
          </div>
        )
      }
    },
    {
      title: 'Present',
      align: 'center',
      dataIndex: 'last_week_attendance',
       render: (value) => {
        return(
          <span>
            {value.present}                
          </span>
          )
      },
    },
    {
      title: 'Absent',
      align: 'center',
      dataIndex: 'last_week_attendance',
       render: (value) => {
        return(
          <span>
            {value.absent}                
          </span>
          )
      },
    },
    {
      title: 'Demo',
      align: 'center',
      dataIndex: 'last_week_attendance',
       render: (value) => {
        return(
          <span>
            {value.demos}                
          </span>
          )
      },
    },
    {
      title: 'Free Filler',
      align: 'center',
      dataIndex: 'last_week_attendance',
       render: (value) => {
        return(
          <span>
            {value.free_fillers}                
          </span>
          )
      },
    },
    {
      title: 'Last Week %',
      align: 'center',
      dataIndex: 'last_week_attendance',
      render: (value) => {
        value =value.percentage
        return(
          <PercentageBadge value={value}/>
          )
      },
      // sorter: (a, b) => a.utilization - b.utilization
    },
    {
      title: '',
      dataIndex: 'id',
      fixed: 'right',
      render: (value) => {
        return(
          <Styled.Icon target="_blank" href={`https://cm.sporthood.in/#/fixtures/${value}/attendance`}>
            <ArrowRightOutlined/>
          </Styled.Icon>
          )
      }
    },
  ]

  const utlization_columns = [
    {
      title: 'Batch',  
      fixed: 'left',
      width: 220,  
      render: (_, record) => {
      const { start_time, end_time, days, multi_timings, id } = record;

      return (
        <div>
          <div>
            {
              (multi_timings && multi_timings.length > 0) ?
              <div>
                {
                  multi_timings.map(x=>(
                    <div style={{display:'flex'}}>
                      <span style={{flex:1}}>{x.day + ' : '}</span>
                      <span style={{flex:4}}>{x.start_time + ' - ' + x.end_time}</span>
                    </div>
                    ))
                }
              </div>
            :
              <div>
                <div>{days}</div>
                <div>{start_time + ' - ' + end_time}</div>
              </div>
            }
          </div>
        </div>
      );
      },
    },

   ...(gameLevel === 'All' ? [{
      title: 'Skill Level',
      align: 'center',
      dataIndex: 'game_level_str',
      sorter: (a, b) => a.game_level_str.localeCompare(b.game_level_str)
    }] : []),

    {
      title: 'Age Group',
      align: 'center',
      dataIndex: 'age_group_str',
      sorter: (a, b) => a.age_group_str.localeCompare(b.age_group_str),
    },
    {
      title: 'Coach',
      dataIndex: 'buddy_names',
      render: (value) => {
        return(
          <div>
            {
              value.map(x=>(
                <div>{x}</div>
                ))
            }
          </div>
          )
      },

    },
    {
      title: 'Capacity',
      align: 'center',
      dataIndex: 'batch_size',
      sorter: (a, b) => a.batch_size - b.batch_size
    },
    {
      title: 'Active',
      align: 'center',
      dataIndex: 'active_count',
      sorter: (a, b) => a.active_count - b.active_count
    },
    {
      title: 'Payment Due',
      align: 'center',
      dataIndex: 'paymentdue_count',
      sorter: (a, b) => a.paymentdue_count - b.paymentdue_count
    },
    {
      title: 'Utilization',
      align: 'center',
      dataIndex: 'utilization',
      render: (value) => {
        return(
          <PercentageBadge value={value}/>
          )
      },
      sorter: (a, b) => a.utilization - b.utilization
    },
    {
      title: 'Potential Leads',
      align: 'center',
      dataIndex: 'potential_lead',
      render: (_, record) => {
        const {  potential_lead,id ,} = record;
        return (
            <Link to={`/leadDetails/?report_no=135700&fixture_id=${record.id}&`} style={{color:'blue'}}>
              {record.potential_lead}
            </Link>
        );},
      sorter: (a, b) => a.potential_lead - b.potential_lead
    },
    {
      title: '',
      dataIndex: 'id',
      fixed: 'right',
      render: (value) => {
        return(
          <Styled.Icon target="_blank" href={`https://cm.sporthood.in/#/fixtures/${value}`}>
            <ArrowRightOutlined/>
          </Styled.Icon>
          )
      }
    },
  ]


  return (
    <Spin spinning={loading} indicator={<Spinner />}>
      <Styled.MainContainer>
        <Styled.TopDiv>    
          <Breadcrumb style={{padding:'10px'}} >
            <Breadcrumb.Item>
              <Link to="/">
                <HomeOutlined />
              </Link>
            </Breadcrumb.Item>

            <Breadcrumb.Item>
                <ContactsOutlined />
                <span style={{paddingLeft:'5px'}}>Batches</span>
            </Breadcrumb.Item>

            <Breadcrumb.Item>
              <Link to="/batches/utilization">
                <span style={{paddingLeft:'5px'}}>Utilization</span>
              </Link>
            </Breadcrumb.Item>

            <Breadcrumb.Item>{venueName}</Breadcrumb.Item>
          </Breadcrumb>
        </Styled.TopDiv>
        <Styled.Header >
          <Tooltip title="Back"><a style={{cursor: 'pointer',color:'#02475c'}} onClick={()=>navigate(-1)}><FaAngleDoubleLeft/></a></Tooltip>
           <a>Batch Utilization {gameType == 8 ? '- Football Academy' : gameType == 10 ? '- Badminton Academy' :gameType == 65 ? '- Swimming Academy' : null} {gameLevel && gameLevel != 'All' ? `- ${gameLevel}` : ''} </a>
           <a></a>
        </Styled.Header>

        {page == 'attendance' &&
          <Typography.Text type="primary" style={{ fontSize: 11, textAlign:'right' }}>
            * <b>Customers</b> count includes <b>active</b> and <b>payment due</b> customers within 14 days after expiry.
            Present, Absent and Last Week % is based on customers. Demos, free fillers and inactive are excluded from these 3 columns
          </Typography.Text>
        }

        <Table
          className="drill-down-table table_container"
          rowKey="id"
          // tableLayout="fixed"
          columns={page == 'utilization' ? utlization_columns : attendance_columns}
          dataSource={batchesData}
          pagination={{ pageSize: 20, showSizeChanger: false}}
          scroll={{ x: 'max-content' }}
         />

      </Styled.MainContainer>
    </Spin>
  );
}

export default BatchDetails;